export const fr = {
  // Header
  nav: {
    home: "Accueil",
    skills: "Compétences",
    experience: "Expérience",
    projects: "Projets",
    contact: "Contact & CV"
  },

  // Home
  home: {
    role: "Responsable d'Exploitation Maintenance",
    bio1: "Bonjour et bienvenue sur mon portfolio ! Je suis actuellement responsable d'exploitation maintenance multi-technique sur un ERP à Montpellier, où je pilote une équipe de 3 techniciens (CVC, électricité, polyvalence) sur un site tertiaire de 70 000 m² accueillant plus de 500 000 visiteurs par an.",
    bio2: "Fort d'une solide expérience terrain et d'une passion pour l'automatisation, je combine management opérationnel et missions transverses (support aux opérations, consolidation des données SAP). J'innove au quotidien pour optimiser les processus via l'Industrie 4.0 (PowerBI, Power Automate), l'économie circulaire (impression 3D) et l'amélioration continue."
  },

  // Language Skills
  languageSkills: {
    french: "Français",
    english: "Anglais",
    spanish: "Espagnol",
    nativeLevel: "Maternelle",
    advancedLevel: "C1",
    intermediateLevel: "B1",
    nativeProficiency: "Langue Maternelle",
    advancedProficiency: "Avancé",
    intermediateProficiency: "Intermédiaire",
    reading: "Lecture",
    writing: "Écriture",
    speaking: "Parler",
    listening: "Écoute",
    basicWriting: "Écriture de base",
    basicSpeaking: "Parler de base",
    proficiency: "Compétence"
  },

  // Tech Skills (just category titles, as there are too many skills to translate)
  techSkills: {
    maintenanceSkills: "Compétences en maintenance",
    gmaoSystems: "Systèmes GMAO et ERP",
    performanceMonitoring: "Suivi de performance",
    continuousImprovement: "Amélioration continue",
    projectManagement: "Gestion de projet",
    designEngineering: "Conception & Ingénierie",
    officeProductivity: "Bureautique & Productivité",
    databasesData: "Bases de données & Données",
    osSystems: "Systèmes d'exploitation & Infrastructure",
    programmingLanguages: "Langages de programmation",
    devOpsTools: "DevOps & Outils",
    webTechnologies: "Technologies Web"
  },

  projectTechnologies: {
    m5stick: "M5 Stick",
    blynk: "Blynk",
    debian: "Debian",
    raspberrypi: "Raspberry Pi",
    apiYaskawa: "API Yaskawa",
    vfd: "VFD",
    energyEfficiency: "Efficacité Énergétique",
    roiAnalysis: "Analyse ROI",
    compressor: "Compresseur",
    economy: "Économie",
    design3d: "Conception 3D",
    printing3d: "Impression 3D",
    cad: "CAD",
    formlabs: "Formlabs",
    sustainability: "Durabilité"
  },

  footer: {
    contact: "Me contacter",
    rights: "Tous droits réservés."
  },

  techSkillsList: {
    maintenance: {
      system: { name: "Maintenance système", details: "Procédures de maintenance préventive et corrective pour équipements industriels et infrastructure IT." },
      reliability: { name: "Fiabilité", details: "Analyse MTBF/MTTR, calcul des indices de fiabilité, revue des défaillances et mise en place de stratégies d'amélioration." },
      predictive: { name: "Maintenance prédictive", details: "Implémentation de systèmes d'analyse prédictive, techniques RCM et suivi vibratoire." },
      tpm: { name: "TPM", details: "Déploiement de la TPM, formation des opérateurs à l'auto-maintenance, élimination des six grandes pertes." },
      troubleshooting: { name: "Dépannage", details: "Diagnostic systématique, analyse des causes racines et résolution pour problèmes mécaniques et logiciels." },
      writing: { name: "Rédaction", details: "Écriture de procédures, modes opératoires, gammes de maintenance, formation." }
    },
    gmao: {
      sap: { name: "SAP", details: "Planning, gamme de maintenance, imputations et gestion des ordres de travail avec SAP PM." },
      dimomaint: { name: "DIMOMAINT", details: "Utilisation de la GMAO DIMOMAINT." },
      cegid: { name: "CEGID PMI", details: "Utilisation de CEGID pour gestion de stock, mouvement, métrologie." },
      aqmanager: { name: "AQMANAGER", details: "Installation, paramétrage et utilisation de l'outil AQMANAGER pour la GMAO." }
    },
    performance: {
      kpi: { name: "KPI", details: "Définition et suivi d'indicateurs de performance clés adaptés aux activités de maintenance et production." },
      dashboards: { name: "Tableaux de bord", details: "Création de tableaux de bord pour suivi parc machines, disponibilité, TRS/OEE et coûts." }
    },
    continuousImprovement: {
      lean: { name: "Lean Management", details: "Application des principes Lean pour réduire les gaspillages, optimiser les flux et créer de la valeur." },
      '5s': { name: "5S", details: "Implémentation des 5S pour l'organisation et la standardisation des postes de travail." },
      kaizen: { name: "Kaizen", details: "Animation d'événements Kaizen, amélioration continue et culture du changement progressif." },
      pareto: { name: "Pareto", details: "Analyse Pareto (80/20), priorisation des problèmes critiques, focus sur les actions à fort impact." }
    },
    projectManagement: {
      jira: { name: "Jira", details: "Suivi de projet, gestion des problèmes et automatisation des flux de travail avec Jira." },
      agile: { name: "AGILE", details: "Méthodologies Agile incluant Scrum et Kanban pour la livraison de projets." },
      sprint: { name: "SPRINT", details: "Planification et animation des cérémonies sprint (planning, revue, rétrospective)." }
    },
    design: {
      fusion: { name: "Fusion 360", details: "Modélisation 3D, conception paramétrique et simulation pour composants mécaniques." },
      arduino: { name: "Arduino", details: "Prototypage IoT et automatisation avec microcontrôleurs Arduino et capteurs." },
      fritzing: { name: "Fritzing", details: "Conception de circuits électroniques et layout PCB pour systèmes embarqués." }
    },
    office: {
      o365: { name: "Office 365", details: "Utilisation avancée suite Office 365, administration SharePoint, Teams et Exchange." },
      powerAutomate: { name: "Power Automate", details: "Automatisation de flux, connecteurs vers divers systèmes et intégrations API." },
      powerApps: { name: "PowerApps", details: "Développement d'applications métier avec sources de données SQL et SharePoint." },
      powerBi: { name: "Power BI", details: "Tableaux de bord interactifs, modèles de données complexes et calculs DAX." }
    },
    data: {
      sql: { name: "SQL", details: "Conception BDD, requêtes complexes, procédures stockées et migrations de données." },
      dax: { name: "DAX", details: "Mesures et colonnes calculées avec Data Analysis Expressions pour Power BI." },
      powerQuery: { name: "Power Query (M)", details: "ETL avec langage M pour transformation et intégration de données." }
    },
    os: {
      debian: { name: "Debian", details: "Administration serveurs, gestion paquets et optimisation système sur base Debian." },
      bash: { name: "Bash/Shell", details: "Automatisation par scripts, traitement de données et opérations planifiées." }
    },
    programming: {
      cpp: { name: "C++", details: "Programmation systèmes embarqués (ESP8266, Raspberry, M5Stack)." },
      csharp: { name: "C#", details: "Applications Windows .NET et intégration bases de données SQL Server." },
      vba: { name: "VBA", details: "Automatisation Excel, fonctions personnalisées et interfaces processus métier." },
      python: { name: "Python", details: "Analyse de données, scripts d'automatisation et intégrations API (Pandas, NumPy)." }
    },
    devops: {
      git: { name: "Git", details: "Contrôle de version, stratégies de branches et travail collaboratif GitHub." },
      llm: { name: "LLM", details: "Utilisation et tweak de LLM (Claude, ChatGPT) pour productivité métier." }
    },
    web: {
      node: { name: "Node.js", details: "Développement API backend, middleware et applications web." }
    }
  },

  // Experience
  experience: {
    title: "Parcours Professionnel",
    present: "Présent",
    years: "an",
    yearsPlural: "ans",
    months: "mois",
    workType: "travail",
    educationType: "éducation",
    certificationType: "certification",
    skillsType: "compétences",
    vinciGlobalPeriod: "Avril 2024 - Présent",
    vinciGlobalLabel: "Période globale VINCI",
    // Experience entries
    experiences: {
      vinci: {
        title: "Chef d'Équipe Maintenance - CFO CFA Région Montpellier",
        company: "VINCI Facilities - Montpellier📍",
        period: "Avril 2024 - Décembre 2025",
        description: "Gestion d'une équipe de 7 personnes responsable de la maintenance courant fort et courant faible (postes HT, groupes électrogènes, intrusion, détection incendie).\n\nPilotage de la maintenance préventive et corrective avec gestion du planning, des astreintes et des priorités opérationnelles.\n\nGestion et suivi des contrats clients, incluant la satisfaction et les engagements contractuels.\n\nCréation de devis, négociation et challenge des fournisseurs pour optimiser les coûts et la qualité des prestations.\n\nMise en place d'améliorations continues par l'automatisation des rapports clients, création et envoi de devis, et gestion des matériels grâce à mes compétences en Excel, PowerApps et Power Automate.\n\nCes optimisations ont permis un gain de 1h30 par jour, améliorant ainsi la productivité et la réactivité client.",
        skills: ["Gestion d'équipe", "Maintenance préventive", "Gestion de contrats", "Automatisation des processus", "SAP", "Excel avancé", "PowerApps", "Power Automate"]
      },
      vinciErp: {
        title: "Responsable d'Exploitation Maintenance - ERP Montpellier",
        company: "VINCI Facilities - Montpellier📍",
        period: "Janvier 2026 - Présent",
        description: "Responsable d'une équipe de 3 techniciens multi-spécialistes (CVC, électricité, factotum) sur un ERP (Établissement Recevant du Public) à Montpellier, un site tertiaire de près de 70 000 m² accueillant plus de 500 000 visiteurs par an.\n\nPilotage de l'exploitation et de la maintenance multi-technique dans un contexte exigeant : contraintes réglementaires, astreintes et continuité de service sur un site à fort flux.\n\nDéveloppement de solutions internes sur-mesure pour améliorer la production et l'efficacité de l'exploitation.\n\n1er au classement individuel (sur plus de 100 participants) au CTF Vinci Energies (Cybersécurité, OSINT, exploitation de vulnérabilités).",
        skills: ["Gestion d'équipe", "CVC", "Électricité", "ERP", "Cybersécurité", "Astreintes", "Multi-technicité", "Power Platform"]
      },
      atole: {
        title: "Technicien de Maintenance",
        company: "ATOLE - Castries📍",
        period: "Septembre 2019 - Avril 2024",
        description: "Entretien des équipements nécessaires à la fabrication d'équipements électriques (coffrets, gaines techniques).\n\nMaintenance préventive et corrective sur les poinçonneuses, découpe laser, soudeuses semi-automatiques, plieuses (grand parc de machines AMADA, TRUMPF).\n\nMaintenance préventive et corrective sur les équipements des équipes de ligne (visseuses pneumatiques, agrafeuse, riveteuses, four à gaz, atelier peinture).\n\nDéveloppement usine 4.0 avec capteurs, Arduino, PowerBI, SQL, Debian et design PCB.\n\nRédaction de plus de 100 documents (mode opératoire, gamme, formation).\n\nAdjoint informel du responsable de la maintenance (gestion, formation nouveaux arrivants, projets).",
        skills: ["Maintenance industrielle", "Équipements AMADA & TRUMPF", "Arduino", "SQL", "Conception de PCB", "PowerBI", "Debian", "Documentation technique"]
      },
      grtgaz: {
        title: "Technicien de Maintenance",
        company: "GRTgaz - Nozay📍",
        period: "Septembre 2016 - Juillet 2019",
        description: "Maintien en service de 5 turbocompresseurs servant à comprimer le gaz, ainsi que du process gaz qui les entourent.\n\nGestion des déchets (enlèvements ADR).\n\nGestion des travaux en coopération avec des entreprises extérieures (souvent étrangères).",
        skills: ["Maintenance turbocompresseurs", "Systèmes gaziers", "Gestion des déchets", "Coordination de prestataires", "Équipements industriels"]
      },
      bts: {
        title: "BTS Maintenance des Systèmes Énergétiques et Fluidiques",
        company: "Formation - Aix En Provence📍",
        period: "2015 - 2016",
        description: "BTS Maintenance des Systèmes Énergétiques et Fluidiques, approfondissement des qualifications précédentes avec une spécialisation dans les systèmes industriels.\n\nEn cours de VAE Licence professionnelle Maintenance.",
        skills: ["Systèmes énergétiques", "Mécanique des fluides", "Maintenance industrielle", "Documentation technique"]
      },
      bac: {
        title: "Baccalauréat Professionnel M.E.I",
        company: "Formation - Istres📍",
        period: "2013 - 2015",
        description: "Baccalauréat professionnel en Maintenance des Équipements Industriels (M.E.I), formation complète sur les techniques de maintenance et les systèmes industriels.",
        skills: ["Maintenance des équipements", "Dépannage", "Dessin technique", "Maintenance préventive"]
      },
      certifications: {
        title: "Certifications Professionnelles",
        company: "Divers organismes de certification",
        period: "2016 - Présent",
        description: "Multiples certifications professionnelles incluant SST (Secourisme au Travail) — équivalent First Aid & CPR/AED (Canada), GIES1 — équivalent Electrical Safety / Arc Flash (NFPA 70E), CACES 3 (Opération d'équipements de levage) — équivalent Forklift Operator Certification (OSHA / CSA B335), SWAGELOCK, HT/BT (Haute/Basse Tension) — équivalent High/Low Voltage Authorization, et utilisation de harnais de sécurité sur sites équipés — équivalent Fall Protection / Working at Heights.",
        skills: ["Certifications de sécurité", "Opération d'équipements", "Sécurité électrique", "Secourisme", "CACES 3"]
      },
      technical: {
        title: "Compétences Techniques",
        company: "Applications & Langages",
        period: "En continu",
        description: "Maîtrise des logiciels GMAO et ERP: SAP, DIMOMAINT, CEGID PMI, AQMANAGER.\n\nBureautique et productivité: Office 365, PowerPlatform.\n\nConception et prototypage: Fusion 360, Arduino, Fritzing.\n\nLangages et systèmes: Debian, Bash, Shell, C++, C#, VBA, PYTHON, SQL, DAX, POWER QUERY (M).",
        skills: ["SAP", "Office 365", "PowerPlatform", "Fusion 360", "Arduino", "Python", "SQL", "VBA"]
      }
    }
  },

  // Appointment Form
  appointment: {
    title: "Mes liens",
    intro: "Responsable Maintenance expérimenté, j'ai développé une solide expertise dans la gestion des équipes, l'optimisation des équipements et l'amélioration continue des processus industriels. Fort de plusieurs années d'expérience, je mets mes compétences au service du développement et de la fiabilité des infrastructures, en alliant stratégie de maintenance et performance opérationnelle.",
    scheduleInterview: "Planifier un entretien",
    scheduleDesc: "Réservez un créneau visio",
    contactLinkedIn: "Me contacter sur LinkedIn",
    linkedInDesc: "Consultez mon profil LinkedIn pour en savoir plus sur mon parcours professionnel",
    sendEmail: "M'envoyer un email",
    emailDesc: "Contactez-moi par mail pour un premier échange",
    downloadCV: "Télécharger mon CV",
    cvDesc: "Obtenez une copie de mon CV pour découvrir mes compétences",
    availability: "Merci de votre visite",
    availabilityStatus: ""
  },

  // Projects
  projects: {
    title: "Mes Projets",
    dmhCounter: {
      title: "Compteur DMH",
      description: "Surveillance du produit en cours de production plus seuil DMH avec alerte pour respect des temps de production."
    },
    compressorEfficiency: {
      title: "Efficacité du Compresseur",
      description: "Analyse des gains d'efficacité de la conversion d'un compresseur d'air en VFD, montrant un retour sur investissement de 2 ans sur un investissement de 20k €."
    },
    threeDPrinting: {
      title: "Économies grâce à l'Impression 3D",
      description: "Plusieurs milliers d'euros d'économies sur plusieurs projets."
    }
  }
};
